export const HEATPUMP_TERMINAL_FCU = 0;
export const HEATPUMP_TERMINAL_RAD = 1;
export const HEATPUMP_TERMINAL_FLH = 2;

export const HEATPUMP_MODE_AUTO = 1;
export const HEATPUMP_MODE_COOLING = 2;
export const HEATPUMP_MODE_HEATING = 3;

export interface TemperatureLimits {
  min: number;
  max: number;
  disabled?: boolean;
}

const HEATING_TERMINAL_LIMITS: Record<number, TemperatureLimits> = {
  [HEATPUMP_TERMINAL_FCU]: { min: 35, max: 65 },
  [HEATPUMP_TERMINAL_RAD]: { min: 35, max: 65 },
  [HEATPUMP_TERMINAL_FLH]: { min: 25, max: 55 },
};

const COOLING_TERMINAL_LIMITS: Record<number, TemperatureLimits> = {
  [HEATPUMP_TERMINAL_FCU]: { min: 5, max: 25 },
  [HEATPUMP_TERMINAL_RAD]: { min: 18, max: 25, disabled: true },
  [HEATPUMP_TERMINAL_FLH]: { min: 18, max: 25 },
};

const HEATING_FALLBACK: TemperatureLimits = { min: 25, max: 65 };
const COOLING_FALLBACK: TemperatureLimits = { min: 5, max: 25 };

function resolveOperationMode(opModeSet?: number, opMode?: number): number {
  if (opModeSet === HEATPUMP_MODE_COOLING || opModeSet === HEATPUMP_MODE_HEATING) {
    return opModeSet;
  }

  if (opMode === HEATPUMP_MODE_COOLING || opMode === HEATPUMP_MODE_HEATING) {
    return opMode;
  }

  return HEATPUMP_MODE_HEATING;
}

function getTerminalLimits(
  mode: number,
  heatingTerminalType?: number,
  coolingTerminalType?: number
): TemperatureLimits {
  if (mode === HEATPUMP_MODE_COOLING) {
    const terminal = coolingTerminalType ?? heatingTerminalType;
    if (terminal !== undefined && COOLING_TERMINAL_LIMITS[terminal]) {
      return { ...COOLING_TERMINAL_LIMITS[terminal] };
    }
    return { ...COOLING_FALLBACK };
  }

  const terminal = heatingTerminalType ?? coolingTerminalType;
  if (terminal !== undefined && HEATING_TERMINAL_LIMITS[terminal]) {
    return { ...HEATING_TERMINAL_LIMITS[terminal] };
  }
  return { ...HEATING_FALLBACK };
}

export function getTCh1SetLimits(
  opModeSet?: number,
  opMode?: number,
  heatingTerminalType?: number,
  coolingTerminalType?: number
): TemperatureLimits {
  const mode = resolveOperationMode(opModeSet, opMode);
  return getTerminalLimits(mode, heatingTerminalType, coolingTerminalType);
}

export function getHeatingSetLimits(
  heatingTerminalType?: number,
  coolingTerminalType?: number
): TemperatureLimits {
  return getTerminalLimits(
    HEATPUMP_MODE_HEATING,
    heatingTerminalType,
    coolingTerminalType
  );
}

export function getCoolingSetLimits(
  heatingTerminalType?: number,
  coolingTerminalType?: number
): TemperatureLimits {
  return getTerminalLimits(
    HEATPUMP_MODE_COOLING,
    heatingTerminalType,
    coolingTerminalType
  );
}
